import * as tslib_1 from "tslib";
import { jsonMapMember, jsonObject } from "typedjson";
import { DxListOptions } from "../list/dx-list-options";
import { DxNodeType } from "./dx-node-type";
let DxTreeListOptions = class DxTreeListOptions extends DxListOptions {
    get nodeTypes() {
        return this._nodeTypes;
    }
    set nodeTypes(value) {
        this._nodeTypes = value;
    }
    get filter() {
        return this._filter;
    }
    set filter(value) {
        this._filter = value;
    }
};
tslib_1.__decorate([
    jsonMapMember(String, DxNodeType, { name: 'nodeTypes', emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Map)
], DxTreeListOptions.prototype, "_nodeTypes", void 0);
tslib_1.__decorate([
    jsonMapMember(String, Object, { name: 'filter', emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Map)
], DxTreeListOptions.prototype, "_filter", void 0);
DxTreeListOptions = tslib_1.__decorate([
    jsonObject
], DxTreeListOptions);
export { DxTreeListOptions };
